import { atom } from "recoil";
export const OperationTypeAtom = atom({
  key: "OperationTypeAtom", // unique ID (with respect to other atoms/selectors)
  default: [], // default value (aka initial value)
});
